import { RiskScenarioCategory } from "./riskScenarioDialog/RiskScenarioDialog.types";

// What a risk scenario can be scored against. Far narrower than the platform-wide EntityType, and numbered on its
// own, so it mirrors the backend RiskScenarioEntityTypeEnum rather than EntityType.
export enum RiskScenarioEntityTypeEnum {
    ProcessingActivity = 1,
    System = 2,
    LegalEntity = 3,
    Organisation = 4,
    Process = 5,
}

export interface RiskScenarioViewModel {
    id: string;
    name: string;
    description?: string;
    category: RiskScenarioCategory;
    appliesToAllRiskAreas: boolean;
    riskAreas: Array<{ id: string; name: string }>;
    appliesToAllEntityTypes: boolean;
    entityTypes: Array<RiskScenarioEntityTypeEnum>;
    createdFromObservation: boolean;
}

export interface RiskScenariosViewModel {
    items: Array<RiskScenarioViewModel>;
    hasCatalogItemsToImport: boolean;
}
